import gql from "graphql-tag";

export const ALL_USERS_QUERY = gql`
  query AllUsersQuery {
    users(orderBy: name_ASC) {
      id
      ldapDN
      email
      name
      roles {
        name
      }
      lockedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/UsersQuery/queries.ts